'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var styled = require('@emotion/styled');
var coreRenderer = require('@tempi/core-renderer');
var React = require('react');
var Ytb = require('react-youtube');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Ytb__default = /*#__PURE__*/_interopDefaultLegacy(Ytb);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Video = React__default["default"].forwardRef(
  (props, ref) => {
    const _a = props, {
      uploadSrc,
      src,
      isEditorMode = false,
      autoplay = false,
      loop = false
    } = _a, rest = __objRest(_a, [
      "uploadSrc",
      "src",
      "isEditorMode",
      "autoplay",
      "loop"
    ]);
    const uploadRender = /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, {
      children: /* @__PURE__ */ jsxRuntime.jsx(StyledVideo, {
        controls: true,
        autoPlay: autoplay,
        loop,
        muted: true,
        src: uploadSrc
      })
    });
    let videoId;
    if (src) {
      videoId = coreRenderer.youtubeParser(src);
    }
    const youtubeRender = /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, {
      children: /* @__PURE__ */ jsxRuntime.jsx(StyledYtb, {
        className: isEditorMode ? "editor-mode" : "",
        containerClassName: "container",
        videoId,
        opts: !isEditorMode ? {
          playerVars: {
            playlist: videoId,
            autoplay: autoplay ? 1 : 0,
            mute: autoplay ? 1 : 0,
            loop: loop ? 1 : 0
          }
        } : {}
      })
    });
    return /* @__PURE__ */ jsxRuntime.jsx(StyledWrapper, __spreadProps(__spreadValues({}, rest), {
      ref,
      children: /* @__PURE__ */ jsxRuntime.jsx(StyledRatio, {
        children: uploadSrc ? uploadRender : youtubeRender
      })
    }));
  }
);
const StyledWrapper = styled__default["default"].div(
  ({ commonStyle }) => `
    ${coreRenderer.getStyle(commonStyle)}
    width: 100%
  `
);
const StyledRatio = styled__default["default"].div`
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  height: 0;
  .container {
    height: 100%;
  }
`;
const StyledYtb = styled__default["default"](Ytb__default["default"])`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  &.editor-mode {
    pointer-events: none;
  }
`;
const StyledVideo = styled__default["default"].video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  &.editor-mode {
    pointer-events: none;
  }
`;
Video.displayName = "Video";

exports.Video = Video;
